import {ofType} from 'redux-observable';
import {of} from 'rxjs';
import {mergeMap, flatMap, catchError} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Actions from './actions';
import * as Api from './api';

const changeEmail = action$ =>
    action$.pipe(
        ofType(Actions.changeEmail.type),
        mergeMap(({payload}) =>
            Api.updateEmail(payload.newEmail).pipe(
                flatMap(() => of(Actions.changeEmailSuccess.action(payload.newEmail))),
                catchError(e => of(Actions.changeEmailFailed.action(e))),
            ),
        ),
    );

export default combineEpics(changeEmail);
